(function () {
  function bindSlider(root) {
    if (root.getAttribute('data-ir-rpt-bound') === 'true') return;
    var sid = root.getAttribute('data-ir-rpt-section');
    if (!sid) return;
    var track = document.getElementById('ir-rpt-track-' + sid);
    var prev = document.getElementById('ir-rpt-prev-' + sid);
    var next = document.getElementById('ir-rpt-next-' + sid);
    if (!track) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    function step() {
      return track.getBoundingClientRect().width || 1;
    }
    function maxScrollLeft() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }
    function atStart() {
      return track.scrollLeft <= 2;
    }
    function atEnd() {
      return track.scrollLeft >= maxScrollLeft() - 2;
    }
    function go(dir) {
      if (isMobile) {
        if (dir > 0 && atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        if (dir < 0 && atStart()) {
          track.scrollTo({ left: maxScrollLeft(), behavior: 'smooth' });
          return;
        }
      }
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      }
    });
    root.setAttribute('data-ir-rpt-bound', 'true');
  }

  document.querySelectorAll('[data-ir-rpt-section]').forEach(bindSlider);
})();
